import Skeleton from 'react-loading-skeleton'
import { StyledFilterBar } from './styles'

export const FilterSkeleton = ({ noBorder }: { noBorder?: boolean }) => {
  return (
    <StyledFilterBar noBorder={noBorder}>
      <Skeleton
        height={'37px'}
        width="200px"
      />
      <Skeleton
        height={'37px'}
        width="160px"
      />
    </StyledFilterBar>
  )
}
